import Button, { ButtonProps } from '@mui/material/Button';
import { Link, LinkProps } from 'react-router-dom';

export const LocalLinkButton = ({
	to,
	children,
	...buttonProps
}: React.PropsWithChildren<
	{
		to: LinkProps['to'];
	} & Omit<ButtonProps, 'to'>
>): React.JSX.Element => (
	<Button
		component={Link}
		variant="contained"
		size="large"
		color="secondary"
		to={to}
		{...buttonProps}>
		{children}
	</Button>
);
